import React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {LinkComposer, LinkProps} from "./link-composer";
import {LinkToModel} from "./link.to-model";
import styles from './link.module.scss';
import classNames from "classnames";
import {SITE_DOMAINS} from "../../consts";

class InternalLinkProps extends LinkProps {
  to: LinkToModel;
  title: String;
  shouldScrollToTop: Boolean;
  shouldStopPropagation: Boolean;
  onClick: Function;
  onLinkClick: Function;
  onMouseEnter: Function;
  onMouseLeave: Function;
  isClickable: Boolean;
  rel: String;
  enabled: Boolean;
  shouldRenderMicroData: Boolean;
  isAnchor: Boolean;
  itemProp: String;
}

export const Link = LinkComposer((props: InternalLinkProps) => {
  if (!props.enabled) {
    const divProps = {
      className: classNames(styles.link, props.className, props.isClickable ? 'clickable' : styles.link_not_clickable),
      style: props.style,
      title: props.title,
      onClick: props.onLinkClick,
      onMouseLeave: () => props.onMouseLeave && props.onMouseLeave(),
      onMouseEnter: () => props.onMouseEnter && props.onMouseEnter(),
      target: props.target,
      id: props.id
    }

    return (
      <span {...divProps}>
        {
          props.shouldRenderMicroData ? <meta itemProp={props.itemProp || "url"} content={`${SITE_DOMAINS.full}${props.to}`}/> : null
        }
        {
          props.children
        }
      </span>
    );
  } else if (props.isAnchor) {
    const anchorProps = {
      className: classNames(styles.link, props.className, 'clickable'),
      style: props.style,
      title: props.title,
      onMouseLeave: () => props.onMouseLeave && props.onMouseLeave(),
      onMouseEnter: () => props.onMouseEnter && props.onMouseEnter(),
      onClick: props.onLinkClick,
      target: props.target,
      id: props.id,
      rel: props.rel,
      href: props.model.toString()
    }

    return <a {...anchorProps}>
      {
        props.shouldRenderMicroData ?
          <meta itemProp={props.itemProp || "url"} content={`${SITE_DOMAINS.full}${props.to}`}/> : null
      }
      {
        props.children
      }
    </a>;
  }

  const routerProps = {
    className: classNames(props.className, styles.link),
    style: props.style,
    replace: props.replace,
    title: props.title,
    to: props.to,
    rel: props.rel,
    onClick: props.onLinkClick,
    onMouseLeave: () => props.onMouseLeave && props.onMouseLeave(),
    onMouseEnter: () => props.onMouseEnter && props.onMouseEnter(),
    target: props.target,
    id: props.id,
    state: props.state
  }

  return (
    <RouterLink {...routerProps}>
      {
        props.shouldRenderMicroData ?
          <meta itemProp={props.itemProp || "url"} content={`${SITE_DOMAINS.full}${props.to}`}/> : null
      }
      {
        props.children
      }
    </RouterLink>
  );
});
